export default({
  namespaced: true,
  state: {
    loading: true,
    language: process.env.DEFAULT_LANGUAGE,
    menu: [],
    unsaved: false,
    languages: {
      hu: {},
      en: {}
    }
  },
  mutations: {
    change (state, payload) {
      // mutate state
      state.loading = payload
    },
    changeLanguage (state, payload) {
      state.language = payload
      localStorage.setItem('language', payload)
    },
    changeUnsaved (state, payload) {
      state.unsaved = payload
    },
    setMenu (state, payload) {
      state.menu = payload
      localStorage.setItem('menu', JSON.stringify(payload))
    },
    setLanguage (state, payload) {
      state.languages[payload.lang] = payload.payload
    }
  },
  getters: {
    getLoading: state => {
      return state.loading
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/modules/loading.js